import { datadogRum } from '@datadog/browser-rum'

import {
  menuRecipeTileFetcher,
  type RecipeUUID,
  transformMenuRecipeTileResponseToRecipe,
} from '@library/menu-service'

import { menuRecipeTileReceived } from 'actions/menu/menuV3'
import { getBasketRecipes, getNumPortions } from 'selectors/basket'
import { getBasketRecipeNumPortions } from 'utils/basket'

import type { GetState } from './types'

export const refreshFlexedRecipeTiles = ({
  dispatch,
  getState,
}: {
  dispatch: any
  getState: GetState
}) => {
  const initialState = getState()
  const menuRequest = initialState.menuMetadata?.request
  const menuId = initialState.menuMetadata?.id
  const boxNumPortions = getNumPortions(initialState)

  if (!menuRequest || !menuId) return

  getBasketRecipes(initialState).forEach((basketRecipe, recipeId) => {
    const numPortions = getBasketRecipeNumPortions(basketRecipe, boxNumPortions)
    if (numPortions === boxNumPortions) return

    void menuRecipeTileFetcher({
      menuId,
      recipeId: recipeId as RecipeUUID,
      numPortions,
      ...(menuRequest.deliveryDate && { deliveryDate: menuRequest.deliveryDate }),
    })
      .then((recipeTile) => {
        const latestState = getState()
        const latestBoxNumPortions = getNumPortions(latestState)
        const latestRecipeNumPortions = getBasketRecipeNumPortions(
          getBasketRecipes(latestState).get(recipeId),
          latestBoxNumPortions,
        )

        if (
          latestState.menuMetadata?.request !== menuRequest ||
          latestState.menuMetadata?.id !== menuId ||
          latestRecipeNumPortions !== numPortions ||
          latestRecipeNumPortions === latestBoxNumPortions
        ) {
          return
        }

        dispatch(menuRecipeTileReceived(transformMenuRecipeTileResponseToRecipe(recipeTile)))
      })
      .catch(() => {
        datadogRum.addAction('recipe_tile_refresh_failed', {
          menu_id: menuId,
          recipe_id: recipeId,
          num_portions: numPortions,
        })
      })
  })
}
